export function formatDecimal(value: any) {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
  
    return new Intl.NumberFormat('nl-NL', { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 0 
    }).format(num);
  }
  